<template>
    <el-form ref="addEventType" :model="new_driver" :rules="formRules" label-position="top"
             class="newEventFormStyle">
        <el-form-item label="Company name" prop="name">
            <el-input v-model="new_driver.name"></el-input>
        </el-form-item>
        <el-form-item label="Car number" prop="carNumber">
            <el-input v-model="new_driver.carNumber"></el-input>
        </el-form-item>
        <el-form-item label="Email" prop="email">
            <el-input v-model="new_driver.email"></el-input>
        </el-form-item>
        <el-form-item label="Password" prop="password">
            <el-input v-model="new_driver.password"></el-input>
        </el-form-item>

    </el-form>
</template>

<script>
    import {mapState} from "vuex";

    export default {
        name: 'AddTaxiDriver',
        props:{new_driver: Object},
        data() {
            return {

            }
        },
        computed:{
          ...mapState({
              user_email: state => state.user.user_email
          })
        },
        beforeMount() {
            this.new_driver.baseEmail = this.user_email
        }
    }
</script>
